"use client";

import { SystemErrorScreen } from "@/components/errors/system-error-screen";

export default function Error({ reset }: { reset: () => void }) {
  return <SystemErrorScreen onRetry={reset} />;
}
